import {Component, isDevMode, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {environment} from "../../../../environments/environment";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {MatTableDataSource} from "@angular/material/table";
import {Centre} from "../../../interfaces/Centres";
import {Vehicle} from "../../../modules/vehicles/vehicles/add-vehicles/add-vehicles.component";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {FormControl} from "@angular/forms";
import {MatSelectChange} from "@angular/material/select";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {VehicleService} from "../../../modules/vehicles/vehicles/vehicle.service";
import {ConfirmDialogComponent} from "../../../confirm-dialog/confirm-dialog.component";
import {MatDialog} from "@angular/material/dialog";
import {ChartConfiguration, ChartOptions} from "chart.js";
@Component({
  selector: 'app-mis-transport',
  templateUrl: './mis-transport.component.html',
  styleUrls: ['./mis-transport.component.scss']
})
export class MisTransportComponent implements OnInit, OnDestroy {
  env = isDevMode() ? environment.testMode : environment.productionMode;
  private _destroyed$ = new Subject<void>();
  dataTableLoaded = false;
  dataSource = new MatTableDataSource<any>();
  lastRow:any;
  mStartDate?: Date | null
  mEndDate?: Date | null
  show = false  //For refetching tables and graphs
  startRange=new Date('2025-02-01')
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) matSort!: MatSort;
  displayedColumns: String[] = [
    'vehicleNumber',
    'vehicleName',
    'vehicleBrand',
    'status',
    'location'
  ];
  selectCentre = new FormControl('All')

  centreSelectionArray = [
    {
      centreName: 'All Centres',
      centreCode: 'All'
    },
    // {
    //     centreName: 'AL Bandra',
    //     centreCode: 'ALBandra'
    // },
    {
      centreName: 'AL Ahmedabad',
      centreCode: 'ALAhmedabad'
    },
    {
      centreName: 'AL Bangalore',
      centreCode: 'ALBangalore'
    },
    {
      centreName: 'AL Borivali',
      centreCode: 'ALBorivali'
    },
    {
      centreName: 'AL Chandigarh',
      centreCode: 'ALChandigarh'
    },

    {
      centreName: 'AL Coimbatore',
      centreCode: 'ALCoimbatore'
    },
    {
      centreName: 'AL Gurunanak Niwas',
      centreCode: 'ALGurunanak'
    },
    {
      centreName: 'AL Diamond Garden',
      centreCode: 'ALDiamondGarden'
    },
    {
      centreName: 'AL Manipal',
      centreCode: 'ALManipal'
    }, {
      centreName: 'AL Pune',
      centreCode: 'ALPune'
    },
    {
      centreName: 'AL Sandu Garden',
      centreCode: 'ALSanduGarden'
    },

  ]

  // cards
  totalDrivers = 0;
  activeDrivers = 0;
  expiringLicenses = 0;

  totalTrips = 0;
  currentTrips = 0;
  tripsWithChild = 0;
  tripsWithoutChild = 0;

  totalVehicles = 0;
  vehiclesOnTrip = 0;
  vehiclesOffTrip = 0;
  vehiclesOnService = 0;
  mostUsedVehicle = '';

  totalKm = 0;
  totalFuel = 0;
  fuelHungryVehicle = '';

  tripsByVehicle: any[] = [];
  tripsByDriver: any[] = [];

  chartOptions: ChartOptions<'bar'> = {
    responsive: true,
    plugins: {
      legend: { display: true, position: 'top' },
      title: { display: false }
    },
    scales: {
      x: { beginAtZero: true },
      y: { beginAtZero: true }
    }
  };

  vehicleChartData: ChartConfiguration<'bar'>['data'] = {
    labels: [],
    datasets: [{ data: [], label: 'Trips', backgroundColor: '#42A5F5' }]
  };

  driverChartData: ChartConfiguration<'bar'>['data'] = {
    labels: [],
    datasets: [{ data: [], label: 'Trips', backgroundColor: '#66BB6A' }]
  };

  driversList: any[] = [];
  tripsList: any[] = [];



  constructor(private firestore : AngularFirestore,
              private mDialog : MatDialog,
              private mService: VehicleService) {

  }

  ngOnInit(): void {
    this.dataTableLoaded = true;
    this.loadDrivers();
    this.loadTrips();
    this.loadVehicles();
    this.loadFuel();
  }
  loadDrivers() {
    this.mService.getDriver().pipe(takeUntil(this._destroyed$)).subscribe((drivers: any[]) => {
      console.log('Fetched Drivers:', drivers);
      this.driversList = drivers;
      // this.dataSource.data = drivers || [];

      // set paginator & sort after data is loaded
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.matSort;

      // cards
      this.totalDrivers = drivers.length;
      this.activeDrivers = drivers.filter(d => d.status === 'active').length;

      const today = new Date();
      const next30 = new Date();
      next30.setDate(today.getDate() + 30);

      this.expiringLicenses = drivers.filter(d => {
        if (!d.expirationDate?.seconds) return false;
        const expiryDate = new Date(d.expirationDate.seconds * 1000);
        return expiryDate <= next30;
      }).length;
    });
  }
  // loadTrips() {
  //   this.mService.getALTrips().subscribe((trips: any[]) => {
  //     console.log('Trips:', trips);
  //     this.tripsList = trips;
  //     // Total trips
  //     this.totalTrips = trips.length;
  //
  //     // Current trips (status = 'Ongoing')
  //     this.currentTrips = trips.filter(t => t?.isRoundTrip == 'true').length;
  //
  //     // With Child
  //     this.tripsWithChild = trips.filter(t => t.triptype?.toLowerCase().includes('with child')).length;
  //
  //     // Without Child
  //     this.tripsWithoutChild = trips.filter(t => t.triptype?.toLowerCase().includes('without child')).length;
  //
  //     // Total KM
  //     this.totalKm = trips.reduce((sum, t) => sum + (t.tripDistanceKm || 0), 0);
  //
  //     // Trips grouped by Vehicle
  //     const byVehicle = this.groupCount(trips.map(t => t.vehicle_info?.vehicleNumber), 'vehicleNumber');
  //     this.tripsByVehicle = byVehicle;
  //     this.mostUsedVehicle = this.getMax(byVehicle);
  //
  //     // Trips grouped by Driver
  //     const byDriver = this.groupCount(trips.map(t => t.vehicle_info?.driverName), 'driverName');
  //     this.tripsByDriver = byDriver;
  //   });
  // }
  loadTrips() {
    this.mService.getALTrips().pipe(takeUntil(this._destroyed$)).subscribe((trips: any[]) => {
      this.tripsList = trips;

      this.totalTrips = trips.length;
      this.currentTrips = trips.filter(t => t?.isRoundTrip == 'true').length;
      this.tripsWithChild = trips.filter(t => t.triptype?.toLowerCase().includes('with child')).length;
      this.tripsWithoutChild = trips.filter(t => t.triptype?.toLowerCase().includes('without child')).length;
      this.totalKm = trips.reduce((sum, t) => sum + (t.tripDistanceKm || 0), 0);

      // Group trips
      const byVehicle: Record<string, number> = {};
      const byDriver: Record<string, number> = {};
      trips.forEach(t => {
        const vehicle = t.vehicle_info?.vehicleNumber || 'Unknown';
        const driver = t.vehicle_info?.driverName || 'Unknown';
        byVehicle[vehicle] = (byVehicle[vehicle] || 0) + 1;
        byDriver[driver] = (byDriver[driver] || 0) + 1;
      });

      this.vehicleChartData = {
        labels: Object.keys(byVehicle),
        datasets: [{ data: Object.values(byVehicle), label: 'Trips per Vehicle', backgroundColor: '#42A5F5' }]
      };
      this.driverChartData = {
        labels: Object.keys(byDriver),
        datasets: [{ data: Object.values(byDriver), label: 'Trips per Driver', backgroundColor: '#66BB6A' }]
      };

      this.mostUsedVehicle = this.getMax(byVehicle);
      // this.tripsByVehicle = byVehicle;
      // this.tripsByDriver = byDriver;
      this.tripsByVehicle = Object.entries(byVehicle).map(([name, value]) => ({ name, value }));
      this.tripsByDriver = Object.entries(byDriver).map(([name, value]) => ({ name, value }));

    });
  }


  loadVehicles() {
    this.mService.getVehicles().pipe(takeUntil(this._destroyed$)).subscribe((vehicles: any[]) => {
      this.dataSource.data = vehicles
      this.totalVehicles = vehicles.length;// On Trip (status = 'on_trip')
      console.log(this.totalVehicles);
      this.vehiclesOnTrip = vehicles.filter(v => v.status?.toLowerCase() === 'on_trip').length;
      this.vehiclesOffTrip = vehicles.filter(v => v.status?.toLowerCase() === 'off_trip').length;
      // Most Used Vehicle (based on servicingDuration or trip count if available)
      if (vehicles.length > 0) {
        let mostUsed = vehicles.reduce((prev, curr) =>
          (parseInt(prev.servicingDuration || 0) > parseInt(curr.servicingDuration || 0)) ? prev : curr
        );
        this.mostUsedVehicle = mostUsed.vehicleName;
      } else {
        this.mostUsedVehicle = 'N/A';
      }

      console.log('Total Vehicles:', this.totalVehicles);
      console.log('On Trip:', this.vehiclesOnTrip);
      console.log('On Service:', this.vehiclesOnService);
      console.log('Most Used Vehicle:', this.mostUsedVehicle);
    });
  }
  loadFuel() {
    this.mService.getCarFuelsData().pipe(takeUntil(this._destroyed$)).subscribe((fuels: any[]) => {
      // Convert fuel quantity (string → number) safely
      this.totalFuel = fuels.reduce(
        (sum, f) => sum + (parseFloat(f.totalQuantityField) || 0),
        0
      );

      // Calculate total KM (sum of meter readings OR difference)
      this.totalKm = fuels.reduce(
        (sum, f) => sum + (parseFloat(f.meterReading) || 0),
        0
      );

      // Group fuel consumption by vehicle
      const byVehicle = this.groupSum(fuels, 'vehicleNumber', 'totalQuantityField');

      // Find vehicle with max fuel usage
      this.fuelHungryVehicle = this.getMax(byVehicle);
    });
  }
  groupCount(arr: any[], field: string) {
    const map = new Map();
    arr.forEach(item => {
      map.set(item[field], (map.get(item[field]) || 0) + 1);
    });
    return Array.from(map, ([key, value]) => ({ name: key, value }));
  }
  // Sum by key (vehicle wise)
  groupSum(data: any[], groupKey: string, sumKey: string) {
    return data.reduce((acc, obj) => {
      const key = obj[groupKey];
      const val = parseFloat(obj[sumKey]) || 0;
      acc[key] = (acc[key] || 0) + val;
      return acc;
    }, {});
  }
// Get max key
  getMax(obj: any) {
    return Object.entries(obj).reduce((max:any, [key, val]:any) =>
      val > (max[1] as number) ? [key, val] : max
    )[0];
  }
  getPercentage(row:any){}
  onCentreSelection($event: MatSelectChange) {
  }

  search() {

  }

  openConfirmationDialog(data: any): void {
    const dialogRef = this.mDialog.open(ConfirmDialogComponent, {
      width: '300px',
      height: '150px',
      data: {
        status: data.status,
        data:data,
        message: 'Do you want to change the status?'
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this._destroyed$)).subscribe((result:any) => {
      if (result) {
        let newStatus = ''
        if(data.status === 'on_trip'){
          newStatus = data.status = 'off_trip';
        }else if(data.status === 'round_trip'){
          newStatus = data.status ='off_trip';
        }
        this.changeStatus(data.id, newStatus,data);
      } else {
        console.log('Status change cancelled');
      }
    });
  }
  changeStatus(id: string, newStatus: string,data:any): void {
    console.log(`Attempting to update status for document ID: ${id} to ${newStatus}`);
    let activity = {
      date: new Date().getTime(),
      section: 'Vehicle',
      action: 'Update',
      description: `Update by user vehicle status by is ,${data.vehicle_info?.firstName+''+data.vehicle_info?.lastName}, ${id}`,
      currentIp: localStorage.getItem('currentip')!,
    };
    // Assuming 'site_products_list' is your collection name
    this.firestore.collection(this.env.vehicles).doc(id).update({
      status: newStatus
    }).then(() => {
      console.log('Status updated successfully for document ID:', id);
      // Optionally, you can refresh the data or show a success message here
    }).catch((error) => {
      console.error('Error updating status:', error);
    });
  }


  resetDate() {

  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}

